export default "__VITE_ASSET__00996083__"